import { useEffect, useState } from "react";
import { AlertCircle, Loader } from "lucide-react";
import { api } from "../api";
import InspectionFillModal from "./InspectionFillModal";
import "../styles.css";

export default function PublicInspectionPage({ token }) {
  const [inspection, setInspection] = useState(null);
  const [unavailable, setUnavailable] = useState(false);

  useEffect(() => {
    api.getPublicInspection(token).then((data) => {
      if (data?.error) setUnavailable(true);
      else setInspection(data);
    }).catch(() => setUnavailable(true));
  }, [token]);

  if (!inspection && !unavailable) return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}><Loader size={32} className="spin" /></div>;
  if (unavailable) return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 20 }}><div style={{ maxWidth: 440, textAlign: "center" }}><AlertCircle size={44} style={{ color: "var(--text-muted)" }} /><h2 style={{ marginTop: 16 }}>Inspección no disponible</h2><p style={{ color: "var(--text-muted)", marginTop: 8 }}>El enlace no es válido o ya fue cerrado. Comunícate con quien te lo compartió.</p></div></div>;
  return <InspectionFillModal inspection={inspection} companies={[]} publicToken={token} onClose={() => {}} />;
}
